<template>
  <Scroll :height="height">
    <Collapse simple style="text-align:left;font-size:16px">
      <Panel name="1">
        设备信息
        <table slot="content">
          <tr>
            <td>设备编号</td>
            <td>{{item.meterId}}</td>
          </tr>
          <!-- <tr>
            <td>设备型号</td>
            <td>{{item.meterSpecifications}}</td>
          </tr>
          <tr>
            <td>设备厂家</td>
            <td>{{item.meterManufacturer}}</td>
          </tr>
          <tr>
            <td>设备类型</td>
            <td>{{item.meterType}}</td>
          </tr>
          <tr>
            <td>设备备注</td>
            <td>{{item.meterRemark}}</td>
          </tr>-->
        </table>
      </Panel>
      <Panel name="2">
        用户信息
        <table slot="content">
          <tr>
            <td>用户姓名</td>
            <td>{{item.customerName}}</td>
          </tr>
          <tr>
            <td>联系电话</td>
            <td>{{item.customerPhone}}</td>
          </tr>
          <tr>
            <td>身份证号</td>
            <td>{{item.customerIdcard}}</td>
          </tr>
          <tr>
            <td>用户地址</td>
            <td>{{item.completeAddress}}</td>
          </tr>
          <!-- <tr>
            <td>用气类型</td>
            <td>{{item.customerGasType}}</td>
          </tr>-->
        </table>
      </Panel>
      <Panel name="3">
        工单信息
        <table slot="content">
          <tr>
            <td>工单编号</td>
            <td>{{item.workOrderId}}</td>
          </tr>
          <tr>
            <td>工单工期</td>
            <td>{{item.workOrderCycle + " " + item.workOrderCycleUnit}}</td>
          </tr>
          <tr>
            <td>创建日期</td>
            <td>{{timestampToTime(item.workOrderInsertDatestamp)}}</td>
          </tr>
        </table>
      </Panel>
    </Collapse>
  </Scroll>
</template>
<script>
export default {
  props: {
    item: {}
  },
  methods: {
    timestampToTime(timestamp) {
      let date = new Date(timestamp);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
    }
  },
  mounted() {
    $("td:even").css("width", "30%");
    $("tr").css("margin-top", "20px");
  },
  created() {},
  data() {
    return {
      height: document.body.clientHeight * 0.7
    };
  }
};
</script>

<style scoped>
table {
  text-align: left;
  width: 100%;
  border: 1px solid #000;
  padding-left: 48px;
}
table tr {
  border: 1px solid #000;
}
</style>
